import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { api } from '../api/client'

/*
 * Public page — no auth required. Recipient lands here from email footer.
 * Shows current sub state, lets them flip it. CAN-SPAM friendly.
 */
export default function SubscriptionPreferencePage() {
    const { trackingId } = useParams()
    const [status, setStatus] = useState<{ contactFound: boolean, isSubscribed: boolean } | null>(null)
    const [reason, setReason] = useState('')
    const [busy, setBusy] = useState(false)
    const [msg, setMsg] = useState<string | null>(null)

    useEffect(() => {
        if (!trackingId) return
        api(`/api/subscribe/${trackingId}`).then(setStatus).catch(e => setMsg(e.message))
    }, [trackingId])

    async function unsubscribe() {
        setBusy(true)
        try {
            await api(`/api/subscribe/${trackingId}/unsubscribe`, {
                method: 'POST', body: JSON.stringify({ reason })
            })
            setMsg("You've been unsubscribed. You won't receive further emails.")
            setStatus({ ...status!, isSubscribed: false })
        } catch (e: any) { setMsg(`Error: ${e.message}`) }
        finally { setBusy(false) }
    }

    async function resubscribe() {
        setBusy(true)
        try {
            await api(`/api/subscribe/${trackingId}/resubscribe`, { method: 'POST' })
            setMsg("You've been resubscribed.")
            setStatus({ ...status!, isSubscribed: true })
        } catch (e: any) { setMsg(`Error: ${e.message}`) }
        finally { setBusy(false) }
    }

    if (!status) return <div style={{ padding: 40, maxWidth: 480, margin: '40px auto' }}>{msg ?? 'Loading...'}</div>

    return (
        <div style={{ padding: 40, maxWidth: 520, margin: '40px auto' }} className="card">
            <h1>Email Preferences</h1>
            {!status.contactFound ? <p>We couldn't find a contact for this link.</p> :
                status.isSubscribed ? <>
                    <p>You are currently <strong>subscribed</strong> to emails from us.</p>
                    <div className="form-row">
                        <label>Reason for unsubscribing (optional)</label>
                        <input value={reason} onChange={e => setReason(e.target.value)} placeholder="Not interested, too frequent..." />
                    </div>
                    <button onClick={unsubscribe} disabled={busy} className="danger" data-testid="unsubscribe">Unsubscribe</button>
                </> : <>
                    <p>You are currently <strong>unsubscribed</strong>.</p>
                    <button onClick={resubscribe} disabled={busy}>Resubscribe</button>
                </>
            }
            {msg && <div className="success" style={{ marginTop: 12 }}>{msg}</div>}
        </div>
    )
}
